var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessengerChat = function SvgMessengerChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 -1 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.98 16v-2.652a.31.31 0 0 0-.13-.274c-1.441-1.14-2.4-2.588-2.73-4.41-.363-2 .083-3.833 1.3-5.455C2.717 1.48 4.472.477 6.595.126 8.672-.218 10.63.14 12.423 1.25s2.988 2.672 3.417 4.754c.455 2.21-.082 4.2-1.517 5.924-1.385 1.666-3.197 2.57-5.338 2.83a8.5 8.5 0 0 1-3.143-.212.4.4 0 0 0-.26.034c-.82.442-1.634.892-2.45 1.339-.038.022-.08.043-.152.08m-.103-6.117.02.034 3.864-2.11 2.035 2.17 4.302-4.569-.02-.02-3.834 2.124-2.088-2.174z"
  })));
};
export default SvgMessengerChat;